<template>
	<div class="input-container input">
		<select v-model="selectedCountry" @change="selectCountry">
			<option
				value=""
				label="--- Select Country ---"
				selected
				disabled
			></option>
			<option
				v-for="country in countries"
				:key="country.code"
				:value="country.code"
			>
				{{ country.name }}
			</option>
		</select>
		<label for="country">Country</label>
	</div>

	<div class="input-container input">
		<select v-model="selectedProvince" :disabled="!provinces.length">
			<option
				value=""
				label="--- Select State / Province ---"
				selected
				disabled
			></option>
			<option
				v-for="province in provinces"
				:key="province.code"
				:value="province.code"
			>
				{{ province.name }}
			</option>
		</select>
		<label for="state">State / Province</label>
	</div>
</template>

<script>
	import { ref, watch } from 'vue';

	export default {
		props: {
			modelValue: Object,
		},
		async setup(props, { emit }) {
			// const selectedCountry = ref(props.modelValue?.country || '');
			// const selectedProvince = ref(props.modelValue?.province || '');
			const selectedCountry = ref('');
			const selectedProvince = ref('');
			const countries = ref([]);
			const provinces = ref([]);

			const fetchCountries = async () => {
				try {
						const { data, error } = await useFetch('/api/country', {
						method: 'GET',
					});

					if (error.value) {
						throw error.value;
					}

					countries.value = data.value.data;
				} catch (error) {
					console.error('Error fetching countries', error);
				}
			};

			const selectCountry = () => {
				const country = countries.value.find(
					(c) => c.code === selectedCountry.value,
				);
				provinces.value = country ? country.provinces : [];
				selectedProvince.value = ''; // Reset province selection
				emit('update:modelValue', {
					country: selectedCountry.value,
					province: selectedProvince.value,
				});
			};

			// Update provinces if the country changes externally
			watch(
				() => props.modelValue?.country,
				(newVal) => {
					selectedCountry.value = newVal;
					selectCountry();
				},
			);

			// Emit province changes
			watch(selectedProvince, (newVal) => {
				emit('update:modelValue', {
					country: selectedCountry.value,
					province: newVal,
				});
			});

			// Fetch countries on mount
			await fetchCountries();

			return {
				selectedCountry,
				selectedProvince,
				countries,
				provinces,
				selectCountry,
			};
		},
	};
</script>
